/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import ProductItem from './ProductItem/ProductItem';

function ProductItems() {
  const productItems = useSelector(state => state.productItems);

  return (
    <>
      {/* Rendering all product items */}
      {productItems.length > 0 ? (
        productItems.map(productItem => (
          <ProductItem key={productItem.productId} productItem={productItem} />
        ))
      ) : (
        <h1>No product found</h1>
      )}
    </>
  );
}

export default ProductItems;
